<template>
    <div class="data_body">
        <div style="width: 100%; height: 100%">
            <div id="charts_canvas" class="echart" style="width: 100%; height: 100%; "></div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        courseArray: {
            type: Array,
        },
    },
    data() {
        return {
            chartObj: null,
            ooption: {
                hours: [],
                days: [],
                data: [],
            },
            option: {
                xAxis: {
                    data: ['三（1）班', '三（2）班', '三（3）班', '三（4）班', '三（5）班', '三（6）班'],

                },
                grid: {
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    top: '5%',
                    containLabel: true
                },
                yAxis: {},
                tooltip: {
                    formatter: (val) => {
                        console.log(val)
                        return val.marker + val.name + '<br/>' +
                            '最低分：' + val.data[1] + '<br/>' +
                            '最高分：' + val.data[2] + '<br/>' +
                            '平均分：' + val.data[3];
                    }
                },
                series: [
                    {
                        type: 'candlestick',
                        data: [
                            [43, 100, 85.5, 85.5],
                            [40, 100, 81.8, 81.8],
                            [38, 98, 78.8, 78.8],
                            [33, 99, 85.2, 85.2],
                            [18, 100, 77, 77],
                            [26, 100, 83.1, 83.1]
                        ]
                    }
                ]
            },
        };
    },
    methods: {
        setChart(option) {
            // 雷达图显示的标签
            let newPromise = new Promise((resolve) => {
                resolve();
            });
            //然后异步执行echarts的初始化函数
            newPromise.then(() => {
                const chartObj = this.$echarts.init(
                    //劳动课程
                    this.$el.querySelector("#charts_canvas")
                );

                // 初始化雷达图
                this.chartObj = chartObj;
                this.chartObj.setOption(this.option);
            });
        },
        setJson(array) {
            this.setChart(this.ooption);
            if (array != undefined && array.length > 0) {
                this.ooption = {
                    hours: [],
                    days: [],
                    data: [],
                }
                let _grade = []
                let _subject = []
                let data = []

                array.forEach(function (item, idx) {
                    _grade.push(item.name)
                })

                array[0].subject.forEach(function (item, idx) {
                    _subject.push(item.name)
                })
                array.forEach(function (item, idx) {
                    item.subject.forEach(function (item2, idx2) {
                        data.push([idx, idx2, item2.course])
                    })
                })
                this.ooption.hours = _subject
                this.ooption.days = _grade
                this.ooption.data = data
                if (!this.chartObj) {
                    this.setChart(this.ooption);
                } else {
                    const hours = this.ooption.hours;
                    // prettier-ignore
                    const days = this.ooption.days;
                    // prettier-ignore
                    const data = this.ooption.data;
                    const title = [];
                    const singleAxis = [];
                    const series = [];
                    days.forEach(function (day, idx) {
                        title.push({
                            textBaseline: 'middle',
                            top: ((idx + 0.5) * 90) / days.length + '%',
                            text: day,
                            textStyle: {
                                fontSize: 12,
                            },
                        });
                        singleAxis.push({
                            left: 70,
                            type: 'category',
                            boundaryGap: false,
                            data: hours,
                            top: (idx * 90) / days.length + 5 + '%',
                            height: 90 / days.length - 10 + '%'
                        });
                        series.push({
                            singleAxisIndex: idx,
                            coordinateSystem: 'singleAxis',
                            type: 'scatter',
                            data: [],
                            symbolSize: function (dataItem) {
                                return dataItem[1] * 3;
                            }
                        });
                    });
                    data.forEach(function (dataItem) {
                        series[dataItem[0]].data.push([dataItem[1], dataItem[2]]);
                    });

                    this.option.title = title
                    this.option.singleAxis = singleAxis
                    this.option.series = series
                    this.chartObj.setOption(this.option);
                }
            }
        }
    },
    watch: {
        courseArray: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                // newValue = newValue.filter(item => {
                //     return ['一年级','二年级','三年级','四年级','五年级','六年级','七年级'].indexOf(item.name) !== -1
                // })
                this.setJson(newValue)
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        // this.courseArray = this.courseArray.filter(item => {
        //     return ['一年级','二年级','三年级','四年级','五年级','六年级','七年级'].indexOf(item.name) !== -1
        // })

        this.setJson(this.courseArray)
        var _this = this;
        window.addEventListener("resize", () => {
            if (_this.chartObj) {
                _this.chartObj.resize();
            }
        });
    },
};
</script>
  
<style scoped>
.data_body {
    height: 100%;
    position: relative;
    border-radius: 5px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 95%;
    background: #fff;
}
</style>
  


// WEBPACK FOOTER //
// src/components/pages/dataBoardSies/school/teacherInfo/index.vue